import Vue from "vue";
import Vuex from "vuex";
import notifications from "./modules/notifications";
import auth, { AuthPlugin } from "./modules/auth";
import language from "./modules/language";
import globalFilters from "./modules/globalFilters";
import codebooks from "./modules/codebooks";
import appParams from "./modules/appParams";
import calendar from "./modules/calendar";
import financial from "./modules/financial";
import documents from "./modules/documents";
import businessUnit from "./modules/businessUnit";
import { BeforeInstallPromptEvent } from "vue-pwa-install"
import reports from "./modules/reports";
import contingent from "./modules/contingent";
import dashboard from "./modules/dashboard";
import reservation from "./modules/reservation";
import reservations from "./modules/reservations"
import maintenance from "./modules/maintenance";
import cashRegister from "./modules/cashRegister";
import appAppearance from "./modules/appAppearance";

Vue.use(Vuex);

type Theme = "light" | "dark";

const state: {
  theme: Theme;
  drawerCollapsed: boolean;
  showMenu: boolean;
  showGrid: boolean;
  customBreadcrumbs?: string[];
  showDatePicker: boolean;
  pwaInstallEvent: BeforeInstallPromptEvent|null|undefined;
} = {
  theme:
    (localStorage.getItem("app.theme") || 0) === "dark" ? "dark" : "light",
  drawerCollapsed: true,
  showMenu: true,
  showGrid: true,
  customBreadcrumbs: undefined,
  showDatePicker: true,
  pwaInstallEvent: undefined,
};

export default new Vuex.Store<any>({
  state: state,
  getters: {
    isLightTheme: (s) => s.theme === "light",
    isDarkTheme: (s) => s.theme !== "light",
    showMenu: (s) => s.showMenu,
    showGrid: (s) => s.showGrid,
    drawerCollapsed: (s) => s.drawerCollapsed,
    customBreadcrumbs: (s) => s.customBreadcrumbs,
    showDatePicker: (s) => s.showDatePicker,
    pwaInstallEvent: (s) => s.pwaInstallEvent,
    canInstallPWA: (s) => s.pwaInstallEvent !== undefined && s.pwaInstallEvent !== null
  },
  actions: {
    setTheme({ commit }, payload: Theme) {
      commit("setTheme", payload);
    },
    toggleTheme({ commit, state }) {
      commit("setTheme", state.theme === "light" ? "dark" : "light");
    },
    setShowMenu({ commit }, value) {
      commit("setShowMenu", value);
    },
    setShowGrid({ commit }, value) {
      commit("setShowGrid", value);
    },
    setDrawerCollapsed({ commit }, value) {
      commit("setDrawerCollapsed", value);
    },
    setShowDatePicker({ commit }, value) {
      commit("setShowDatePicker", value);
    },
    setCustomBreadcrumbs({ commit }, value) {
      commit("setCustomBreadcrumbs", value);
    },
    setPwaInstallEvent({ commit }, payload: BeforeInstallPromptEvent) {
      commit("setPwaInstallEvent", payload);
    }
  },
  mutations: {
    setTheme(state, payload: Theme) {
      localStorage.setItem("app.theme", payload);
      state.theme = payload;
    },
    setShowMenu(state, payload: boolean) {
      state.showMenu = payload;
    },
    setShowGrid(state, payload: boolean) {
      state.showGrid = payload;
    },
    setDrawerCollapsed(state, payload: boolean) {
      state.drawerCollapsed = payload;
    },
    setShowDatePicker(state, payload: boolean) {
      state.showDatePicker = payload;
    },
    setCustomBreadcrumbs(state, payload: string[] | undefined) {
      state.customBreadcrumbs = payload;
    },
    setPwaInstallEvent(state, payload: BeforeInstallPromptEvent) {
      state.pwaInstallEvent = payload;
    }
  },
  modules: {
    notifications,
    auth,
    globalFilters,
    language,
    codebooks,
    appParams,
    calendar,
    financial,
    documents,
    businessUnit,
    reports,
    contingent,
    dashboard,
    reservation,
    reservations,
    maintenance,
    cashRegister,
    appAppearance
  },
  plugins: [AuthPlugin],
});
